<div class="instruction-list-paragraph">

  @if (data.self.attributes.field_instruction_list_title) {
    <h2
      class="instruction-list-paragraph__title">
      {{data.self.attributes.field_instruction_list_title}}
    </h2>
  }

  @if (tags) {
    <ul
      class="instruction-list-paragraph__items">
      @for (tag of tags; track tag) {
        <li>
          <a [routerLink]="tag.path">{{tag.name}}</a>
        </li>
      }
    </ul>
  }

</div>